import { createFileRoute } from '@tanstack/react-router'
import { Mail } from 'lucide-react'
import { useNewsletterSubscribers } from '@/lib/newsletter'

function NewsletterPage() {
  const { data, isLoading, isError, error } = useNewsletterSubscribers(true)

  return (
    <div className="p-2 md:p-4 space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white flex items-center gap-2">
          <Mail className="w-6 h-6" /> Newsletter Subscribers
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Real signups from the storefront footer (TenantService's NewsletterController).
          {data && <span className="ml-1 font-medium text-gray-800 dark:text-gray-200">{data.total} active.</span>}
        </p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
        {isLoading ? (
          <p className="p-6 text-gray-500">Loading subscribers…</p>
        ) : isError ? (
          <p className="p-6 text-red-600">Failed to load subscribers: {(error as Error)?.message}.</p>
        ) : !data || data.items.length === 0 ? (
          <p className="p-6 text-gray-500">No subscribers yet.</p>
        ) : (
          <table className="min-w-full text-left text-sm">
            <thead className="bg-gray-50 dark:bg-gray-900/40 text-gray-500">
              <tr>
                <th className="px-4 py-2">Email</th>
                <th className="px-4 py-2">Source</th>
                <th className="px-4 py-2">Subscribed</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((s) => (
                <tr key={s.id} className="border-t border-gray-100 dark:border-gray-700">
                  <td className="px-4 py-3 font-medium text-gray-800 dark:text-gray-100">{s.email}</td>
                  <td className="px-4 py-3 text-gray-600 dark:text-gray-300">{s.source ?? '—'}</td>
                  <td className="px-4 py-3 text-gray-600 dark:text-gray-300">{new Date(s.subscribedAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

export const Route = createFileRoute('/(admin)/newsletter/')({
  component: NewsletterPage,
})
